import { IWhatsAppNumbersProps } from '../../../../services/WhatsAppNumberService/types';
import zod from 'zod';
import { WhatsAppNumberFormSchema } from '../../../../services/WhatsAppNumberService/schemas';
import React, { useContext, useEffect } from 'react';
import { AppContext } from '../../../../context/AppContextProvider';
import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import ModalComponent from '../../../../components/ModalComponent';
import { Grid2 } from '@mui/material';
import TextFieldComponent from '../../../../components/TextFieldComponent';
import ButtonComponent from '../../../../components/ButtonComponent';
import {
  useCreateWhatsAppNumber,
  useUpdateWhatsAppNumber,
} from '../../../../services/WhatsAppNumberService/hooks/useMutation';

interface IWhatsAppNumberEditionModal {
  selectedItem?: IWhatsAppNumbersProps;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  handleForm: () => void;
}

type WhatsAppNumberEditionFormInput = zod.infer<
  typeof WhatsAppNumberFormSchema
>;

const WhatsAppNumberEditionModal = ({
  selectedItem,
  isOpen,
  setIsOpen,
  handleForm,
}: IWhatsAppNumberEditionModal) => {
  const { showSnackbar } = useContext(AppContext);
  const { control, reset, handleSubmit } =
    useForm<WhatsAppNumberEditionFormInput>({
      resolver: zodResolver(WhatsAppNumberFormSchema),
      defaultValues: {
        id: undefined,
        name: '',
        phoneNumber: '',
      },
    });
  const {
    mutateAsync: mutateCreateWhatsAppNumber,
    isLoading: isLoadingCreate,
  } = useCreateWhatsAppNumber();
  const {
    mutateAsync: mutateUpdateWhatsAppNumber,
    isLoading: isLoadingUpdate,
  } = useUpdateWhatsAppNumber();

  const handleClose = () => {
    setIsOpen(false);
    reset();
  };

  const handleEdition = (data: WhatsAppNumberEditionFormInput) => {
    data.phoneNumber = data.phoneNumber.replace(/\D/g, '');

    if (selectedItem?.id) {
      mutateUpdateWhatsAppNumber({ id: selectedItem.id, data: data }).then(
        () => {
          resetAndShowMessage('Contato do WhatsApp atualizado com sucesso!');
        },
      );
    } else {
      mutateCreateWhatsAppNumber(data).then(() => {
        resetAndShowMessage('Contato do WhatsApp criado com sucesso!');
      });
    }
  };

  const resetAndShowMessage = (message: string) => {
    showSnackbar(message, 'success');
    reset();
    setIsOpen(false);
    handleForm();
  };

  useEffect(() => {
    if (selectedItem) reset(selectedItem, { keepDefaultValues: true });
  }, [selectedItem]);
  return (
    <ModalComponent
      title={
        selectedItem
          ? 'Editar Contato do WhatsApp'
          : 'Adicionar Contato do WhatsApp'
      }
      onClose={handleClose}
      isOpen={isOpen}
    >
      <Grid2 container size={12} spacing={3}>
        <Grid2 display={'flex'} justifyContent={'center'} size={12}>
          <Grid2 display={'column'} size={6} justifyContent={'center'}>
            <Controller
              render={({
                field: { value, onChange },
                fieldState: { error },
              }) => (
                <TextFieldComponent
                  label="Nome"
                  onChangeText={(val) => onChange(val)}
                  type={'text'}
                  errorMessage={error?.message}
                  value={value}
                />
              )}
              name={'name'}
              control={control}
            />
            <Controller
              render={({
                field: { value, onChange },
                fieldState: { error },
              }) => (
                <TextFieldComponent
                  mask={'(00) 0 0000-0000'}
                  label="Número de Celular"
                  onChangeText={(val) => onChange(val)}
                  type={'text'}
                  errorMessage={error?.message}
                  value={value}
                  maxLength={17}
                />
              )}
              name={'phoneNumber'}
              control={control}
            />
          </Grid2>
        </Grid2>
        <Grid2 display={'flex'} size={12}>
          <ButtonComponent
            type="submit"
            variant="contained"
            color="primary"
            loading={isLoadingCreate || isLoadingUpdate}
            fullWidth
            onClick={handleSubmit(handleEdition)}
          >
            Salvar
          </ButtonComponent>
        </Grid2>
      </Grid2>
    </ModalComponent>
  );
};

export default WhatsAppNumberEditionModal;
